// The comparison key for a staff email: the «(tú)» row, a person already in the list and the add
// check. App-service canonicalizes on its own side; this copy only spares a round trip.
export function canonicalEmail(raw: string): string {
  return raw.trim().toLowerCase();
}

// What gets pasted is often a whole address line from a mail client («Ana García <ana@…>») or the
// tail of a sentence («ana@…,»). Only the address is kept; anything else is returned trimmed and
// left to the validation, never guessed into an address.
const BRACKETED = /<([^<>]*)>/;
const TRAILING_MARK = /[.,]$/;

export function extractEmail(pasted: string): string {
  const bracketed = BRACKETED.exec(pasted)?.[1];
  return (bracketed ?? pasted).trim().replace(TRAILING_MARK, '').trim();
}

// App-service's canonical staff email, checked on the already canonical string (trimmed and
// lower-cased): printable ASCII only, so no spaces and no look-alike letter from another alphabet;
// exactly one «@»; a non-empty local part without a «+» alias; and the citibox.com domain itself,
// with no subdomain and no second domain. Upper-case letters are left out of the local part too, as
// a canonical string never holds them. Anything else never reaches the list as if it were someone.
const CITIBOX_EMAIL = /^[\x21-\x2a\x2c-\x3f\x5b-\x7e]+@citibox\.com$/;

export function isCitiboxEmail(canonical: string): boolean {
  return CITIBOX_EMAIL.test(canonical);
}
